import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"

const RequestsList = () => {
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const fetchRequests = async () => {
    setLoading(true)
    setError("")
    const url = `${getAPIBaseURL()}/v1/posts/user/posts`
    const headers = {}
    const params = { limit: 50, skip: 0 }
    const res = await getData(url, headers, params)
    setLoading(false)
    if(res.error == ""){
      if(res.result.status === 200){
        setRequests(res.result.data?.data || [])
      }else{
        setError(res.result.data?.message || 'Could not load requests')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  useEffect(()=>{ fetchRequests() }, [])

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleString()
    }catch(e){
      return iso
    }
  }

  return (
    <div className="mx-auto max-w-6xl px-3 sm:px-0">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-900 sm:text-xl">My Requests</h2>
          <p className="text-xs text-gray-500 sm:hidden">Tap a request to view details</p>
        </div>
        <Link
          to="/dashboard/requests/new"
          className="inline-flex items-center justify-center rounded-lg bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-gray-900 sm:text-sm"
        >
          New Request
        </Link>
      </div>
      <div className="rounded-lg bg-white shadow-sm border border-gray-200">
        {loading ? (
          <div className="p-4 sm:p-6 text-sm text-gray-500">Loading...</div>
        ) : error ? (
          <div className="p-4 sm:p-6 text-sm text-red-600">{error}</div>
        ) : requests.length === 0 ? (
          <div className="p-4 sm:p-6 text-sm text-gray-500">No requests yet</div>
        ) : (
          <ul className="divide-y divide-gray-200">
            {requests.map((req)=> (
              <li key={req._id} className="p-4 sm:p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
                  <div className="min-w-0 flex-1">
                    <div className="mb-1 flex flex-wrap items-center gap-2">
                      <span className="font-mono text-[11px] text-gray-500 break-all">
                        {req.requestId || req._id}
                      </span>
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
                        req.status === 'PAID' ? 'bg-green-100 text-green-700' :
                        req.status === 'DELIVERED' ? 'bg-blue-100 text-blue-700' :
                        req.status === 'RECEIVED' ? 'bg-purple-100 text-purple-700' :
                        req.status === 'PRICED' ? 'bg-yellow-100 text-yellow-700' :
                        req.status === 'CANCELLED' ? 'bg-red-100 text-red-700' :
                        'bg-gray-100 text-gray-700'
                      }`}>
                        {req.status || 'PENDING'}
                      </span>
                    </div>
                    <p className="mt-1 line-clamp-3 text-sm text-gray-700">{req.message}</p>
                    <p className="mt-1 text-xs text-gray-400">{formatDate(req.createdAt)}</p>
                  </div>
                  <div className="flex flex-wrap gap-2 sm:shrink-0 sm:flex-nowrap">
                    <Link
                      to={`/dashboard/requests/${req._id}`}
                      className="w-full sm:w-auto rounded-lg border border-gray-200 px-3 py-2 text-xs font-medium text-gray-700 hover:bg-gray-50 text-center"
                    >
                      Open
                    </Link>
                    {req.status === 'PENDING' || req.status === 'PRICED' ? (
                      <Link
                        to={`/dashboard/requests/${req._id}/edit`}
                        className="w-full sm:w-auto rounded-lg border border-gray-200 px-3 py-2 text-xs font-medium text-gray-700 hover:bg-gray-50 text-center"
                      >
                        Edit
                      </Link>
                    ) : null}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default RequestsList


